// extracted by mini-css-extract-plugin
module.exports = {"card":"Layout_card__31jEI"};